import { BaseElementToSimpleSapElementMapper } from '../baseElementToSimpleSapElementMapper';
import Element, { SpecyficType } from '@/models/element';
import { ISimpleSapElement, SimpleSapElement } from '@/models/api/models/simpleSapElement';

export class FrontToSimpleSapElementMapper extends BaseElementToSimpleSapElementMapper {

    private color: string = '';
    private element: Element;

    public map(element: Element): ISimpleSapElement[] {
        this.element = element;
        this.color = this.toColor(element);
        if (element.specyficType === SpecyficType.DRAWER_FRONT) {
            const drawerFront = this.getDrawerFront();
            return [drawerFront, drawerFront];
        } else {
            const front = this.getFront();
            return [front];
        }
    }

    private getDrawerFront() {
        const type = this.formatType('FRS', this.element.shape.x, 1);
        return SimpleSapElement.ELEMENT(type, this.color)
    }

    private getFront() {
        const type = this.formatType('DRZ', this.element.shape.y, this.element.shape.x);
        return SimpleSapElement.ELEMENT(type, this.color);
    }
}
